import * as tf from "@tensorflow/tfjs";

export async function loadModel() {
  // clear the model variable
  let model;
  // load the model using a HTTPS request (where you have stored your model files)
  model = await tf.loadLayersModel("/models/model.json");

  const warmupResult = await model.predict(tf.zeros([81, 28, 28, 1]));
  warmupResult.dataSync(); // we don't care about the result
  warmupResult.dispose();
  return model;
}

export async function convertImgsToTensor(imageArr, canvas) {
  var t0 = performance.now();
  let imgProcessedArr = [];
  for (let i = 0; i < imageArr.length; ++i) {
    let dataArr = Array.from(imageArr[i].data);
    let img = dataArr.map((e) => e / 255);
    img = Array.from(img);
    imgProcessedArr = imgProcessedArr.concat(img);
    // window.cv.imshow(canvas, imageArr[11]);
  }

  let tensor = tf.tensor4d(imgProcessedArr, [81, 28, 28, 1]);

  var t1 = performance.now();
  // console.log(
  //   "Converting images to Tensor took " + (t1 - t0) + " milliseconds."
  // );

  return tensor;
}

export async function modelPredict(model, tensor) {
  var t0 = performance.now();
  let predictions = await model.predict(tensor);
  const out = predictions.dataSync();
  predictions.dispose();
  // get the model's prediction results
  var t1 = performance.now();
  // console.log("model inference took " + (t1 - t0) + " milliseconds.");
  return out;
}
